export const teamMemberData = [
  {
    name: "Tomas Hajek",
    role: "Integrasjons- og løsningsekspert",
    roleEnglish: "Integration and Solution Expert",
    image: require("../../images/team/Tomas.JPG"),
    competence: [
      {
        title: "CCM",
        things: ["OpenText Exstream", "Quadient Inspire", "Andre CCM-løsninger"]
      },
      {
        title: "Universelt utformede dokumenter",
        things: ["PDF/UA og WCAG"]
      },
      {
        title: "Informasjons- og dokumentflyt",
        things: [
          "Multikanal løsninger",
          "Data & Content Analytics",
          "IBM Watson Explorer"
        ]
      },
      {
        title: "Tjenesteorientert arkitektur",
        things: [
          "API REST/SOAP",
          "Authentication & Authorisation",
          "Meldingskøer",
          "Databaser (MS SQL, Postres)",
          "Java, Spring Boot",
          "DevOps for MS Azure Cloud",
          "ReactJS"
        ]
      },
      {
        title: "IT operativsystemer og infrastruktur",
        things: [
          "Windows (network and Active Directory)",
          "Linux",
          "Shell scripting"
        ]
      },
      {
        title: "",
        things: ["Teknisk mentor"]
      }
    ],
    competenceEnglish: [
      {
        title: "CCM",
        things: ["OpenText Exstream", "Quadient Inspire", "Other CCM solutions"]
      },
      {
        title: "Universally designed documents",
        things: ["PDF/UA and WCAG"]
      },
      {
        title: "Information and document flow",
        things: [
          "Multi-channel solutions",
          "Data & Content Analytics",
          "IBM Watson Explorer"
        ]
      },
      {
        title: "Service-oriented architecture",
        things: [
          "API REST/SOAP",
          "Authentication & Authorisation",
          "Message queues",
          "Databases (MS SQL, Postgres)",
          "Java, Spring Boot",
          "DevOps for MS Azure Cloud",
          "ReactJS"
        ]
      },
      {
        title: "IT operating systems and infrastructure",
        things: [
          "Windows (network and Active Directory)",
          "Linux",
          "Shell scripting"
        ]
      },
      {
        title: "",
        things: ["Technical mentor"]
      }
    ],
  },
  {
    name: "Suparna Chowdhury ",
    role: "Løsningsekspert og utvikler",
    roleEnglish: "Solution Expert and Developer",
    image: require("../../images/team/Suparna.png"),
    competence: [
      {
        title: "CCM/Dokumentløsninger",
        things: ["OpenText Exstream", "FileNet", "IBM Content Manager", "Flowize", "Metaforce"]
      },
      {
        title: "Universelt Utformede dokumenter",
        things: ["PDF/UA med WCAG"]
      },
      {
        title: "Cloud services",
        things: ["Azure", "GCP", "IBM Cloud"]
      },
      {
        title: "Programming, markup, server",
        things: ["Python", "Java", "HTML", "XML", "VBScript", "Windows PowerShell", "Linux, Windows"]
      },
      {
        title: "Database/BI løsninger",
        things: ["Oracle", "SQL", "Mongo DB", "Cassandra", "Power BI"]
      },

    ],
    competenceEnglish: [
      {
        title: "CCM/Document solutions",
        things: ["OpenText Exstream", "FileNet", "IBM Content Manager", "Flowize", "Metaforce"]
      },
      {
        title: "Universally designed documents",
        things: ["PDF/UA and WCAG"]
      },
      {
        title: "Cloud services",
        things: ["Azure", "GCP", "IBM Cloud"]
      },
      {
        title: "Programming, markup, server",
        things: ["Python", "Java", "HTML", "XML", "VBScript", "Windows PowerShell", "Linux, Windows"]
      },
      {
        title: "Database/BI solutions",
        things: ["Oracle", "SQL", "Mongo DB", "Cassandra", "Power BI"]
      }
    ]
  },
  {
    name: "Yaowapa Pornsamutsin",
    role: "Løsningsekspert og utvikler",
    roleEnglish: "Solution Expert and Developer",
    image: require("../../images/team/Yao.JPG"),
    competence: [
      {
        title: "CCM/Dokumentløsninger",
        things: ["OpenText Exstream", "Flowize", "PlanetPress", "GMC", "Metaforce"]
      },
      {
        title: "Database/Datavarehus/BI løsninger",
        things: ["WhereScape", "MS SQL Server", "Oracle DB", "SQL-T"]
      },
      {
        title: "Programmering og markup",
        things: ["VBScript", "Windows PowerShell", "BAT", "XML", "HTML", "CSS"]
      },
      {
        title: "UU",
        things: ["Adobe Pro DC", "Kofax Power PDF", "NVDA"]
      }
    ],
    competenceEnglish: [
      {
        title: "CCM/Document solutions",
        things: ["OpenText Exstream", "Flowize", "PlanetPress", "GMC", "Metaforce"]
      },
      {
        title: "Database/Data warehouse/BI solutions",
        things: ["WhereScape", "MS SQL Server", "Oracle DB", "SQL-T"]
      },
      {
        title: "Programming and markup",
        things: ["VBScript", "Windows PowerShell", "BAT", "XML", "HTML", "CSS"]
      },
      {
        title: "UU",
        things: ["Adobe Pro DC", "Kofax Power PDF", "NVDA"]
      }
    ],
  },

  {
    name: "Pål Vinland",
    role: "Løsningsekspert og utvikler",
    roleEnglish: "Solution Expert and Developer",
    image: require("../../images/team/Pål.JPG"),
    competence: [
      {
        title: "CCM & dokumentløsninger",
        things: ["Løsningsdesign", "Informasjons- og dokumentflyt", "OpenText Communications (Exstream)", "Andre CCM-løsninger", "Medlem av OpenText Communications (Exstream) Product Advisory Board"]
      },
      {
        title: "Universell utforming av dokumenter",
        things: ["PDF/UA & WCAG", "Adobe Pro DC", "OpenText Output Transformation Server"]
      },
      {
        title: "Programmering og markup",
        things: ["XML", "JSON", "HTML", "CSS", "JavaScript"]
      }
    
    ],
    competenceEnglish: [
      {
        title: "CCM & document solutions",
        things: ["Solution design", "Information and document flow", "OpenText Communications (Exstream)", "Other CCM-solutions", "Member of OpenText Communications (Exstream) Product Advisory Board"]
      },
      {
        title: "Universal design of documents",
        things: ["PDF/UA & WCAG", "Adobe Pro DC", "OpenText Output Transformation Server"]
      },
      {
        title: "Programming and markup",
        things: [
          "XML",
          "JSON",
          "HTML",
          "CSS",
          "JavaScript"
        ],
      },
    ],
  },
  {
    name: "Pavel Pajer",
    role: "Integrasjons- og løsningsekspert",
    roleEnglish: "Integration and Solution Expert",
    image: require("../../images/team/Pavel.JPG"),
    competence: [
      {
        title: "CCM/Dokumentløsninger",
        things: ["OpenText Exstream", "Quadient Inspire", "IBM Content Manager", "IBM Filenet"]
      },
      {
        title: "Universelt utformede dokumenter",
        things: ["PDF/UA og WCAG"]
      },
      {
        title: "Tjenesteorientert arkitektur",
        things: ["API REST/SOAP", "Meldingskøer", "Databaser (MS SQL,Oracle, Postres)", "Java, Spring", "ReactJS", "DevOps for MS Azure Cloud"]
      },
      {
        title: "IT operativsystemer og infrastruktur",
        things: ["Windows (network og Active Directory)", "Linux", "Shell scripting"]
      },
      
    ],
    competenceEnglish: [
      {
        title: "CCM/Document solutions",
        things: ["OpenText Exstream", "Quadient Inspire", "IBM Content Manager", "IBM Filenet"]
      },
      {
        title: "Universally designed documents",
        things: ["PDF/UA and WCAG"]
      },
      {
        title: "Service-oriented architecture",
        things: ["API REST/SOAP", "Message queues", "Databases (MS SQL,Oracle, Postres)", "Java, Spring", "ReactJS", "DevOps for MS Azure Cloud"]
      },
      {
        title: "IT operating systems and infrastructure",
        things: ["Windows (network and Active Directory)", "Linux", "Shell scripting"]
      },
     
    ]
  },
  {
    name: "Vidar Berge",
    role: "Senior arkitekt",
    roleEnglish: "Senior Architect",
    image: require("../../images/team/Vidar.JPG"),
    competence: [
      {
        title: "CCM/Dokumentløsninger",
        things: [
          "OpenText Exstream",
          "Quadient Inspire",
          "Metaforce",
          "IBM Content Manager",
          "IBM Content Manager OnDemand",
          "FileNet",
          "SAP Archivelink - Content Collector for SAP",
          "Versafile docuflow"
        ]
      },
      {
        title: "Tjenesteorientert arkitektur",
        things: [
          "REST/SOAP",
          "Meldingskøer",
          "Databaser (MS SQL, PostgreSQL, Oracle, DB2)",
          "IBM WebSphere"
        ]
      },
      {
        title: "IT operativsystemer og infrastruktur",
        things: ["Mainframe", "Windows", "Linux", "AIX"]
      },
      {
        title: "Programmering",
        things: ["Mainframe REXX", "Perl", "Python", "Power Shell"]
      }
    ],
    competenceEnglish: [
      {
        title: "CCM/Document solutions",
        things: [
          "OpenText Exstream",
          "Quadient Inspire",
          "Metaforce",
          "IBM Content Manager",
          "IBM Content Manager OnDemand",
          "FileNet",
          "SAP ArchiveLink - Content Collector for SAP",
          "Versafile docuflow"
        ]
      },
      {
        title: "Service-oriented architecture",
        things: [
          "REST/SOAP",
          "Message queues",
          "Databases (MS SQL, PostgreSQL, Oracle, DB2)",
          "IBM WebSphere"
        ]
      },
      {
        title: "IT operating systems and infrastructure",
        things: ["Mainframe", "Windows", "Linux", "AIX"]
      },
      {
        title: "Programming",
        things: ["Mainframe REXX", "Perl", "Python", "PowerShell"]
      }
    ],
  },
  {
    name: "Jens Ugland",
    role: "Fullstack utvikler",
    roleEnglish: "Fullstack Developer",
    image: require("../../images/team/jensugland.png"),
    competence: [
      {
        title: "Webutvikling",
        things: [
          "HTML, CSS, JavaScript, PHP",
          "ReactJS, TypeScript, Tailwind CSS, NodeJS",
        ],
      },
      {
        title: "Utvikling",
        things: [
          "Phyton, Java, SpringBoot, C",
          "API REST/SOAP, SQL, Semantic web",
          "TDD, Azure",
        ],
      },
      {
        title: "Grafisk design",
        things: [
          "Adobe Photoshop",
          "Adobe Premier Pro",
          "Adobe Illustator",
          "Adobe XD",
          "Figma",
        ],
      },
      {
        title: "Universelt utforming",
        things: ["PDF/UA og WCAG"]
      }
    ],
    competenceEnglish: [
      {
        title: "Web development",
        things: [
          
          "HTML, CSS, JavaScript, Php", 
          "React, TypeScript, Tailwind CSS, NodeJS",
         
        ],
      },
      {
        title: "Development",
        things: [
          "Phyton, Java, SpringBoot, C",
          "API REST/SOAP, SQL, Semantic web",
          "TDD, Azure",
        ],
      },
      {
        title: "Graphic design",
        things: [
          "Adobe Photoshop",
          "Adobe Premier Pro",
          "Adobe Illustator",
          "Adobe XD",
          "Figma",
        ],
      },
      {
        title: "Universally designed documents",
        things: ["PDF/UA and WCAG"]
      },
    ],
  },

  {
    name: "Bjarne Sørum",
    role: "Daglig leder",
    roleEnglish: "Daily Leader",
    image: require("../../images/team/Bjarne.jpg"),
    competence: [
      {
        title: "Management og utvikling",
        things: [
          "Administrasjon",
          "Finans",
          "IT Strategi",
          "Prosjektstyring",
          "Applikasjonsutvikling"
        ]
      },
      {
        title: "IT løsninger",
        things: [
          "Prosessautomatisering og digitalisering",
          "Betalingsløsninger",
          "Universell Utforming",
          "Informasjons- og dokumentflyt",
          "Enterprise Content Management",
          "Customer Communication Management"
        ]
      },
   
    ],
    competenceEnglish: [
      {
        title: "Management and development",
        things: [
          "Administration",
          "Finance",
          "IT Strategy",
          "Project management",
          "Application development"
        ]
      },
      {
        title: "IT solutions",
        things: [
          "Process automation and digitalization",
          "Payment solutions",
          "Universal Design",
          "Information and document flow",
          "Enterprise Content Management",
          "Customer Communication Management"
        ]
      },
    ],
  },
  {
    name: "Ivar Iversen",
    role: "Seniorkonsulent og prosjektleder",
    roleEnglish: "Consultant",
    image: require("../../images/team/ivar.jpg"),
    competence: [
      {
        title: "CCM/Dokumentløsninger",
        things: ["OpenText Exstream"]
      },
      {
        title: "Prosjekt",
        things: ["DePict (bygger på PRINCE II)", "MS Surestep", "MS Project"]
      },
      {
        title: "Universelt utformede dokumenter",
        things: ["PDF/UA og WCAG"]
      },
      {
        title: "Tjenesteorientert arkitektur",
        things: ["ERP", "CRM", "TCM"]
      },
      {
        title: "IT operativsystemer og infrastruktur",
        things: ["Windows (network og Active Directory)", "MS SQL"]
      }
    ],
    competenceEnglish: [
      {
        title: "CCM/Document solutions",
        things: ["OpenText Exstream"]
      },
      {
        title: "Project",
        things: ["DePict (based on PRINCE II)", "MS Surestep", "MS Project"]
      },
      {
        title: "Universally designed documents",
        things: ["PDF/UA and WCAG"]
      },
      {
        title: "Service-oriented architecture",
        things: ["ERP", "CRM", "TCM"]
      },
      {
        title: "IT operating systems and infrastructure",
        things: ["Windows (network and Active Directory)", "MS SQL"]
      }
    ],
  }
];

export const partnersData = [
  {
    name: "David Gabrielsen",
    role: "Utvikler",
    roleEnglish: "Developer",
    image: require("../../images/team/partnerteam/Presentasjon-David-Gabrielsen.jpg"),
    competence: [
      {
        title: "CCM/Dokumentløsninger",
        things: ["OpenText Exstream", "StreamServe"]
      },
      {
        title: "IT operativsystemer og infrastruktur",
        things: ["Linux, Windows", "Databaser (MS SQL, Oracle, DB2)", "Jira, GitHub"]
      },
      {
        title: "Utvikling",
        things: [
          "JavaScript/node.js",
          "Python/Flask",
          "VB/ASP",
          "Perl/PHP",
          "C++/C#",
          "Ruby",
          "SQL",
          "LUA",
          "Windows PowerShell",
          "XML/HTML/CSS/XSLT/XPATH"
        ]
      },
      {
        title: "Annet",
        things: [
          "Adobe Premiere Pro",
          "Adobe Photoshop",
          "DaVinci Resolve",
          "Cubase"
        ]
      }
    ],
    competenceEnglish: [
      {
        title: "CCM/Document solutions",
        things: ["OpenText Exstream", "StreamServe"]
      },
      {
        title: "IT operating systems and infrastructure",
        things: ["Linux, Windows", "Databases (MS SQL, Oracle, DB2)", "Jira, GitHub"]
      },
      {
        title: "Development",
        things: [
          "JavaScript/node.js",
          "Python/Flask",
          "VB/ASP",
          "Perl/PHP",
          "C++/C#",
          "Ruby",
          "SQL",
          "LUA",
          "Windows PowerShell",
          "XML/HTML/CSS/XSLT/XPATH"
        ]
      },
      {
        title: "Other",
        things: [
          "Adobe Premiere Pro",
          "Adobe Photoshop",
          "DaVinci Resolve",
          "Cubase"
        ]
      }
    ]
  },
  {
    name: "Frode Antonsen",
    role: "Utvikler",
    roleEnglish: "Developer",
    image: require("../../images/team/partnerteam/Presentasjon-Frode-Antonsen.jpg"),
    competence: [
      {
        title: "CCM/Dokumentløsninger",
        things: [
          "Integrasjon og løsningsdesign",
          "OpenText Exstream",
          "OpenText StreamServe",
          "StreamServe Collector",
          "EzeScan"
        ]
      },
      {
        title: "IT operativsystemer og infrastruktur",
        things: ["Windows", "Print/Fax drivere", "Databaser (MS SQL)", "Jira"]
      },
      {
        title: "Annet",
        things: [
          "Kursleder StreamServe Basic & Advanced",
          "StreamServe script language",
          "E2B/EHF"
        ]
      }
    ],
    competenceEnglish: [
      {
        title: "CCM/Document solutions",
        things: [
          "Integration and solution design",
          "OpenText Exstream",
          "OpenText StreamServe",
          "StreamServe Collector",
          "EzeScan"
        ]
      },
      {
        title: "IT operating systems and infrastructure",
        things: ["Windows", "Print/Fax drivers", "Databases (MS SQL)", "Jira"]
      },
      {
        title: "Other",
        things: [
          "Course leader StreamServe Basic & Advanced",
          "StreamServe script language",
          "E2B/EHF"
        ]
      }
    ]
  },
  {
    name: "Gaute Amundsen",
    role: "Løsningsekspert og utvikler",
    roleEnglish: "Solution Expert and Developer",
    image: require("../../images/team/partnerteam/Presentasjon-Gaute-Amundsen.jpg"),
    competence: [
      {
        title: "CCM/Dokumentløsninger",
        things: [
          "Integrasjon og løsningsdesign",
          "OpenText Exstream",
          "OpenText Content Server",
          "StreamServe Collector"
        ]
      },
      {
        title: "IT operativsystemer og infrastruktur",
        things: [
          "Linux, Windows, Azure, GCP",
          "Databaser (MS SQL, Oracle, DB2)",
          "Docker, Kubernetes",
          "MS DevOps, Jira, GitHub"
        ]
      },
      {
        title: "Utvikling",
        things: [
          "Webutvikling",
          "Python, Flask, OAuth, SQL, CSS, vanilla-JS",
          "OAuth, LDAP, AD",
          "OpenText Directory Services (OTDS)",
          "Adhoc analyse og verktøy",
          "Python, JavaScript, Java",
          "Bash, PS, Lua, TCL",
          "XPath, XSLT",
          "SQL, T-sql, SQL Tuning"
        ]
      },
      {
        title: "Annet",
        things: [
          "ISO 20022 - finansmeldinger",
          "PAIN001/2 CAMT045 & Telepay"
        ]
      }
    ],
    competenceEnglish: [
      {
        title: "CCM/Document solutions",
        things: [
          "Integration and solution design",
          "OpenText Exstream",
          "OpenText Content Server",
          "StreamServe Collector"
        ]
      },
      {
        title: "IT operating systems and infrastructure",
        things: [
          "Linux, Windows, Azure, GCP",
          "Databases (MS SQL, Oracle, DB2)",
          "Docker, Kubernetes",
          "MS DevOps, Jira, GitHub"
        ]
      },
      {
        title: "Development",
        things: [
          "Web development",
          "Python, Flask, OAuth, SQL, CSS, vanilla-JS",
          "OAuth, LDAP, AD",
          "OpenText Directory Services (OTDS)",
          "Ad hoc analysis and tools",
          "Python, JavaScript, Java",
          "Bash, PS, Lua, TCL",
          "XPath, XSLT",
          "SQL, T-sql, SQL Tuning"
        ]
      },
      {
        title: "Other",
        things: [
          "ISO 20022 - financial messages",
          "PAIN001/2 CAMT045 & Telepay"
        ]
      }
    ]
  },
  {
    name: "Preben Danielsen",
    role: "Utvikler",
    roleEnglish: "Developer",
    image: require("../../images/team/partnerteam/Presentasjon-Preben-Danielsen.jpg"),
    competence: [
      {
        title: "CCM/Dokumentløsninger",
        things: ["OpenText Exstream"]
      },
      {
        title: "IT operativsystemer og infrastruktur",
        things: ["Azure", "Docker, Kubernetes", "GitHub"]
      },
      {
        title: "Utvikling",
        things: ["C#, Java, PowerShell", "XPath, XSLT"]
      }
    ],
    competenceEnglish: [
      {
        title: "CCM/Document solutions",
        things: ["OpenText Exstream"]
      },
      {
        title: "IT operating systems and infrastructure",
        things: ["Azure", "Docker, Kubernetes", "GitHub"]
      },
      {
        title: "Development",
        things: ["C#, Java, PowerShell", "XPath, XSLT"]
      }
    ]
  },
  {
    name: "Terje Mjørud",
    role: "Utvikler",
    roleEnglish: "Developer",
    image: require("../../images/team/partnerteam/Presentasjon-Terje-Mjørud.jpg"),
    competence: [
      {
        title: "CCM/Dokumentløsninger",
        things: [
          "Integrasjon og løsningsdesign",
          "OpenText Exstream"
        ]
      },
      {
        title: "IT operativsystemer og infrastruktur",
        things: ["Windows", "Databaser (MS SQL)", "Jira, GitHub"]
      },
      {
        title: "Utvikling",
        things: [
          "Java, C#",
          "PowerShell",
          "SQL, T-SQL, XPath",
          "REST API, SOAP"
        ]
      },
      {
        title: "Meldingsformater",
        things: ["PEPPOL BIS, EHF, cXML"]
      },
      {
        title: "Aksesspunkt",
        things: ["Logiq, SAP ARIBA"]
      }
    ],
    competenceEnglish: [
      {
        title: "CCM/Document solutions",
        things: [
          "Integration and solution design",
          "OpenText Exstream"
        ]
      },
      {
        title: "IT operating systems and infrastructure",
        things: ["Windows", "Databases (MS SQL)", "Jira, GitHub"]
      },
      {
        title: "Development",
        things: [
          "Java, C#",
          "PowerShell",
          "SQL, T-SQL, XPath",
          "REST API, SOAP"
        ]
      },
      {
        title: "Message formats",
        things: ["PEPPOL BIS, EHF, cXML"]
      },
      {
        title: "Access points",
        things: ["Logiq, SAP ARIBA"]
      }
    ]
  }
]
